import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/activeBonus/active_bonus_top_banner.png'
import _imports_1 from '@/assets/activeBonus/active_bonus_item_disable.png'


const _hoisted_1 = { class: "mainContainer" }
const _hoisted_2 = { class: "banner" }
const _hoisted_3 = ["src"]
const _hoisted_4 = {
  key: 1,
  src: _imports_0,
  alt: ""
}
const _hoisted_5 = { class: "yesterdayCard" }
const _hoisted_6 = { class: "text1" }
const _hoisted_7 = { class: "text2" }
const _hoisted_8 = {
  key: 0,
  src: _imports_1,
  alt: ""
}
const _hoisted_9 = { class: "todayCard" }
const _hoisted_10 = { class: "subtodayCard" }
const _hoisted_11 = { class: "text1" }
const _hoisted_12 = { class: "text2" }
const _hoisted_13 = { class: "bonusList" }
const _hoisted_14 = { class: "listTitle" }
const _hoisted_15 = { class: "bottom_text" }


import CustomHeader from '../components/common/customHeader.vue';
import { ActiveBonusData } from '@/view/activeBonus/supportScript';


export default /*@__PURE__*/_defineComponent({
  __name: 'activeBonusView',
  props: {
    dataSet: {}
  },
  emits: ['activeBonusClaim'],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emits = __emit

const activeBonusClaim = () => {
   emits('activeBonusClaim')
}

return (_ctx: any,_cache: any) => {
  const _component_van_col = _resolveComponent("van-col")!
  const _component_van_row = _resolveComponent("van-row")!
  const _component_van_icon = _resolveComponent("van-icon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(CustomHeader, {
      text: _ctx.$t('activityName.active_bonus')
    }, null, 8, ["text"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (_ctx.dataSet.flatIcon)
          ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              src: _ctx.dataSet.flatIcon,
              alt: ""
            }, null, 8, _hoisted_3))
          : (_openBlock(), _createElementBlock("img", _hoisted_4)),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_van_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_van_col, { span: "16" }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t('chest.yesterdayBet')) + " R$ " + _toDisplayString(_ctx.dataSet.yesterBetAmount), 1),
                  _createElementVNode("div", _hoisted_7, [
                    _createTextVNode(_toDisplayString(_ctx.$t('chest.bonus')) + " R$ ", 1),
                    _createElementVNode("span", null, _toDisplayString(_ctx.dataSet.yesterRewardAmount), 1)
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_van_col, {
                span: "8",
                class: "claimBtn"
              }, {
                default: _withCtx(() => [
                  (_ctx.dataSet.yesterRewardAmount <= 0)
                    ? (_openBlock(), _createElementBlock("img", _hoisted_8))
                    : (_openBlock(), _createElementBlock("div", {
                        key: 1,
                        class: "activeClaimBtn",
                        onClick: activeBonusClaim
                      }, _toDisplayString(_ctx.$t('activity.reciev')), 1))
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _createVNode(_component_van_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_van_col, { span: "16" }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.$t('chest.todayBet')) + " R$ " + _toDisplayString(_ctx.dataSet.todayBetAmount), 1),
                  _createElementVNode("div", _hoisted_12, [
                    _createTextVNode(_toDisplayString(_ctx.$t('chest.bonus')) + " R$ ", 1),
                    _createElementVNode("span", null, _toDisplayString(_ctx.dataSet.todayRewardAmount), 1)
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _createVNode(_component_van_row, { class: "infoContainer" }, {
          default: _withCtx(() => [
            _createVNode(_component_van_col, {
              span: "2",
              style: {"text-align":"right","padding":"0 1%"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_van_icon, {
                  name: "info",
                  color: "#fff",
                  size: "18"
                })
              ]),
              _: 1
            }),
            _createVNode(_component_van_col, { span: "22" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('chest.info',{startTime: _ctx.dataSet.activityConfig?.claim_start_time, endTime: _ctx.dataSet.activityConfig?.claim_end_time})), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.$t('chest.activeBonusTitle')), 1),
        _createVNode(_component_van_row, { class: "tabelhead" }, {
          default: _withCtx(() => [
            _createVNode(_component_van_col, { span: "10" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('common.bets')), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_van_col, { span: "14" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('chest.luckBonus')), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dataSet.rewardList, (item, index) => {
          return (_openBlock(), _createBlock(_component_van_row, {
            key: index,
            class: "tabelRow",
            style: _normalizeStyle({
                backgroundColor: index % 2 === 1 ? ' rgba(255, 255, 255, 0.02)' : 'rgba(255, 255, 255, 0.04)'
            })
          }, {
            default: _withCtx(() => [
              _createVNode(_component_van_col, {
                span: "10",
                class: "tabelText"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("R$ " + _toDisplayString(item.bet), 1)
                ]),
                _: 2
              }, 1024),
              _createVNode(_component_van_col, {
                span: "14",
                class: "tabelText"
              }, {
                default: _withCtx(() => [
                  _cache[0] || (_cache[0] = _createElementVNode("span", null, "R$", -1)),
                  _createTextVNode(_toDisplayString(item.reward_coin), 1)
                ]),
                _: 2
              }, 1024)
            ]),
            _: 2
          }, 1032, ["style"]))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_15, [
        _createVNode(_component_van_row, { style: {"padding-bottom":"10px"} }, {
          default: _withCtx(() => [
            _createVNode(_component_van_col, {
              span: "6",
              class: ""
            }, {
              default: _withCtx(() => _cache[1] || (_cache[1] = [
                _createElementVNode("div", { class: "line1" }, null, -1)
              ])),
              _: 1
            }),
            _createVNode(_component_van_col, {
              span: "12",
              class: "title"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", null, _toDisplayString(_ctx.$t("common.activityTitle")), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_van_col, {
              span: "6",
              class: ""
            }, {
              default: _withCtx(() => _cache[2] || (_cache[2] = [
                _createElementVNode("div", { class: "line2" }, null, -1)
              ])),
              _: 1
            })
          ]),
          _: 1
        }),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dataSet.activityIntro, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "line_text",
            key: index
          }, _toDisplayString(item), 1))
        }), 128))
      ])
    ])
  ], 64))
}
}

})